module.exports = __webpack_public_path__ + "img/nicole_labes.baba2ed8.png";